// SPDX-License-Identifier: AGPL-3.0-or-later
import {SERVER_BADGE_ASSETS} from '@app/features/guild/utils/ServerBadgeAssets';
import {remFromPx} from '@app/features/theme/layout/RemFromPx';
interface PartneredBadgeIconProps { size?: number; className?: string; }
export function PartneredBadgeIcon({size = 16, className}: PartneredBadgeIconProps) {
  return <img src={SERVER_BADGE_ASSETS.partnered} alt="" aria-hidden="true" draggable={false} style={{width:remFromPx(size),height:remFromPx(size)}} className={className} data-flx="ui.icons.partnered-badge-icon.img" />;
}
